"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Spinner = _interopRequireDefault(require("../Spinner"));
var _excluded = ["disabled", "isLoading", "testId", "children", "className", "kind", "noFill", "neutral", "theme", "isCircular", "size", "isFocused", "buttonRef"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var defaultProps = {
  kind: 'primary',
  neutral: false,
  noFill: false,
  theme: {},
  onClick: function onClick() {},
  disabled: false,
  isLoading: false,
  isCircular: false,
  size: 'md',
  isFocused: false
};

/**
 * Buttons are used to make common actions immediately visible and easy to perform with one click, tap, or keypress.
 */
var Button = exports["default"] = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(Button, _React$Component);
  function Button(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, Button);
    _this = _callSuper(this, Button, [props]);
    _this.handleClick = _this.handleClick.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }
  (0, _createClass2["default"])(Button, [{
    key: "handleClick",
    value: function handleClick() {
      var _this$props = this.props,
        onClick = _this$props.onClick,
        disabled = _this$props.disabled,
        isLoading = _this$props.isLoading;
      if (!disabled && !isLoading) {
        onClick.apply(void 0, arguments);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        disabled = _this$props2.disabled,
        isLoading = _this$props2.isLoading,
        testId = _this$props2.testId,
        children = _this$props2.children,
        className = _this$props2.className,
        kind = _this$props2.kind,
        noFill = _this$props2.noFill,
        neutral = _this$props2.neutral,
        theme = _this$props2.theme,
        isCircular = _this$props2.isCircular,
        size = _this$props2.size,
        isFocused = _this$props2.isFocused,
        buttonRef = _this$props2.buttonRef,
        others = (0, _objectWithoutProperties2["default"])(_this$props2, _excluded);
      var composedClassName = (0, _classnames["default"])('button', className, theme.button, kind && theme[kind], (noFill || neutral) && theme.noFill, neutral && theme.neutral, disabled && theme.disabled, isLoading && theme.isLoading, isCircular && theme.circular, size && theme[size]);
      var handleRef = function handleRef(element) {
        if (element && isFocused) {
          element.focus();
        }
        if (buttonRef && typeof buttonRef === 'function') {
          // return the DOM node `<button>`
          buttonRef(element);
        }
      };
      var props = _objectSpread(_objectSpread({}, others), {}, {
        'disabled': disabled || isLoading,
        'className': composedClassName,
        'onClick': this.handleClick,
        'data-test-id': testId,
        'data-anypoint-component': Button.displayName,
        'ref': handleRef
      });
      return /*#__PURE__*/_react["default"].createElement("button", props, children ? /*#__PURE__*/_react["default"].createElement("span", {
        className: (0, _classnames["default"])('button-children', theme.children)
      }, children) : null, isLoading ? /*#__PURE__*/_react["default"].createElement(_Spinner["default"], {
        className: (0, _classnames["default"])('button-spinner', theme.spinner),
        size: "s"
      }) : null);
    }
  }]);
  return Button;
}(_react["default"].Component);
(0, _defineProperty2["default"])(Button, "defaultProps", defaultProps);
(0, _defineProperty2["default"])(Button, "displayName", 'Button');
//# sourceMappingURL=Button.js.map